<span id="mitsTableWrapper" #mitsTableWrapper *ngIf="table">
  <span class="mitsTableHeader" [ngClass]="{'fullWidthSearch': forceOpenSearchBar}">
    <span *ngIf="table.header?.length > 0" [ngClass]="{'mitsTableCardDesign': table.cardDesign}"
      class="mitsTableTitle">{{table.header}}</span>
    <span class="mitsTableToolbar">
      <span *ngIf="!table.hideSearch" class="mitsTableButton"
        [ngClass]="{'active': searchBarOpen || forceOpenSearchBar, 'disabled': table.disableSearch}"
        (click)="clickSearchButton($event)">
        <mits-icon *ngIf="!searchBarOpen || forceOpenSearchBar" name="search"></mits-icon>
        <mits-icon *ngIf="searchBarOpen && !forceOpenSearchBar" name="close"></mits-icon>
      </span>
      <input type="text" *ngIf="!table.hideSearch" #searchInput [(ngModel)]="searchText"
        (input)="debounceSearch($event)" class="mitsTableSearchInput"
        [ngClass]="{'opened': searchBarOpen || forceOpenSearchBar}">
      <mits-filter-button *ngIf="!table.hideFilters || false" [disabled]="table.disableFilters || false"
        (filtersChanged)="changedFilters($event)" (filtersClosed)="closedFilters($event)" [sortables]="sortableData"
        [defaultSortable]="defaultSortable || {name: 'remote_id', title: 'ID'}"
        [defaultDirection]="'DESC'"></mits-filter-button>
      <span *ngIf="!table.hideAdd" class="mitsTableButton leftSeperator"
        [ngClass]="{'disabled': table.disableAdd, 'withText': !showLeftMenuIcons}" (click)="clickAddButton($event)">
        <mits-icon *ngIf="showLeftMenuIcons" name="add"></mits-icon>
        <ng-container *ngIf="!showLeftMenuIcons">Hinzufügen</ng-container>
      </span>
      <span *ngIf="table.groupBy && table.groupBySelect" class="mitsTableButton leftSeperator"
        [ngClass]="{'active': selectedGroupValues.length, 'withText': !showLeftMenuIcons}" (click)="openGroupingSelection()">
        <ion-icon *ngIf="showLeftMenuIcons" name="layers-outline"></ion-icon>
        <ng-container *ngIf="!showLeftMenuIcons">Gruppierung{{ selectedGroupValues.length ? ' (' + selectedGroupValues.length + ')' : '' }}</ng-container>
      </span>
      <span *ngIf="table.globalFilter" class="mitsTableButton leftSeperator"
        [ngClass]="{'withText': !showLeftMenuIcons}" (click)="toggleFilterVisability()">
        <ion-icon *ngIf="showLeftMenuIcons" name="filter-outline"></ion-icon>
        <ng-container *ngIf="!showLeftMenuIcons">Filter {{ globalFiltersVisible ? 'ausblenden' : 'anzeigen'
          }}</ng-container>
      </span>
    </span>
  </span>
  <ng-template *ngTemplateOutlet="buttonTemplate"></ng-template>
  <ng-container *ngIf="table.globalFilter && globalFiltersVisible" [formGroup]="globalFilters">
    <ion-item *ngFor="let filter of table.globalFilter.filters">
      <ion-label>{{ filter.label }}</ion-label>
      <ion-select placeholder="wählen" [multiple]="filter.multiple" [formControlName]="filter.attribute"
        okText="Bestätigen" cancelText="Abbrechen">
        <ion-select-option *ngIf="!filter.multiple" value="">Alle</ion-select-option>
        <ion-select-option *ngFor="let o of globalFilterValues[filter.attribute]" [value]="o">
          {{ o }}
        </ion-select-option>
      </ion-select>
    </ion-item>
  </ng-container>
  <span class="mitsTableTable">
    <p id="tableDescr">{{table.header || ''}}</p>
    <table [ngClass]="{'fixedLayout': table.disableContentWrap || table.setTableLayoutFixed}"
      aria-describedby="tableDescr">
      <tr>
        <ng-container *ngFor="let columnHead of table.columns">
          <th [ngClass]="{
            'leftText': columnHead.alignment === 'left', 
            'centerText': columnHead.alignment === 'center', 
            'rightText': columnHead.alignment === 'right', 
            'disableWrapping': forceDisableContentWrap ? false : columnHead.disableContentWrap || table.disableContentWrap
          }" [ngStyle]="{'width': columnHead.width + 'px'}"
            *ngIf="this.columnHead.minSizeThreshold ? !mitsTableHelper.isPixelsInThreshold(tableWidth, this.columnHead.minSizeThreshold) : true">
            {{!mitsTableHelper.isPixelsInThreshold(tableWidth, this.table.shortenTitleThreshold || 'md') ?
            columnHead.title.default : columnHead.title.shorten ? columnHead.title.shorten : columnHead.title.default}}
          </th>
        </ng-container>
        <th *ngIf="table.enableInlineEditing || table.actionsMenuButtons?.length > 0" class="centerText"
          [ngStyle]="{'width': table.actionsMenuColumnWidth + 'px'}" i18n>
          Aktionen
        </th>
      </tr>
      <ng-container *ngIf="data">
        <ng-container
          *ngFor="let dataItem of (data | destroyFilter | searchFilter:searchText:(isUnboundTable && searchBarOpen) | groupBy:activeGroupBy); let i = index">
          <tr *ngIf="activeGroupBy && dataItem.mitsTable_firstElement">
            <ng-container>
              <th
                [attr.colspan]="table.columns.length + (table.enableInlineEditing || table.actionsMenuButtons?.length > 0 ? 1 : 0)"
                class="groupHeaderItem">
                {{dataItem[activeGroupBy]}}
              </th>
            </ng-container>
          </tr>
          <tr (click)="clickItem($event, dataItem, i)"
            [style.background-color]="shouldHighlight(dataItem) ? table.highlightIfTrue?.bgColor || '#db504a55' : ''"
            [ngClass]="{'canClick': !table.disableItemClick && !shouldDisable(dataItem), 'canHover': !table.disableHoverEffect && !shouldDisable(dataItem)}">
            <ng-container *ngFor="let columnInfo of table.columns">
              <td [ngClass]="{
              'leftText': columnInfo.alignment === 'left', 
              'centerText': columnInfo.alignment === 'center', 
              'rightText': columnInfo.alignment === 'right', 
              'disableWrapping': forceDisableContentWrap ? false : columnInfo.disableContentWrap || table.disableContentWrap, 'biggerHeight': !deviceTypes.desktop && !table.disableTouchResizing
            }" [ngStyle]="{'width': columnInfo.width + 'px'}"
                *ngIf="this.columnInfo.minSizeThreshold ? !mitsTableHelper.isPixelsInThreshold(tableWidth, this.columnInfo.minSizeThreshold) : true">
                <ng-container [ngSwitch]="columnInfo.type">
                  <div class="iconWrapper" *ngSwitchCase="'boolean-icon'">
                    <mits-icon *ngIf="getValuePipe.transform(dataItem, columnInfo)" name="check-outline"
                      class="success"></mits-icon>
                    <mits-icon *ngIf="!getValuePipe.transform(dataItem, columnInfo)" name="close-outline"
                      class="danger"></mits-icon>
                  </div>
                  <div class="iconWrapper" *ngSwitchCase="'boolean-icon-mono'">
                    <mits-icon *ngIf="getValuePipe.transform(dataItem, columnInfo)" name="check-outline"></mits-icon>
                  </div>
                  <div class="centerText" *ngSwitchCase="'boolean-text'">
                    <ng-container *ngIf="getValuePipe.transform(dataItem, columnInfo); else elseBooleanCheckmark">
                      Ja
                    </ng-container>
                    <ng-template #elseBooleanCheckmark>
                      Nein
                    </ng-template>
                  </div>
                  <div *ngSwitchCase="'date'">
                    {{dataItem | getValue:columnInfo | date:'dd.MM.yyyy'}}
                  </div>
                  <div *ngSwitchCase="'datetime'">
                    {{dataItem | getValue:columnInfo | date:'dd.MM.yyyy HH:mm'}}
                  </div>
                  <div *ngSwitchCase="'percentage'">
                    {{dataItem | getValue:columnInfo | number:'1.0-2':'de'}}%
                  </div>
                  <div *ngSwitchCase="'euro'">
                    {{dataItem | getValue:columnInfo | number:'1.2-2':'de'}} €
                  </div>
                  <div *ngSwitchCase="'dollar'">
                    ${{dataItem | getValue:columnInfo | number:'1.2-2':'en'}}
                  </div>
                  <div class="iconWrapper" *ngSwitchCase="'icon'">
                    <mits-icon [name]="getValuePipe.transform(dataItem, columnInfo)"></mits-icon>
                  </div>
                  <div class="iconWrapper" *ngSwitchCase="'css-icon'">
                    <span class="gg-{{getValuePipe.transform(dataItem, columnInfo)}}"></span>
                  </div>
                  <ng-container *ngSwitchCase="'color'">
                    <div #colorBox class="colorBox"
                      [ngStyle]="{'background-color': getValuePipe.transform(dataItem, columnInfo), 'color': mitsTableHelper.getContrastColor(getValuePipe.transform(dataItem, columnInfo))}">
                      {{dataItem | getValue:columnInfo}}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'phone-number'">
                    <a class="link" (click)="$event.stopPropagation()"
                      [href]="generatePhoneHref(getValuePipe.transform(dataItem, columnInfo))">
                      {{dataItem | getValue:columnInfo}}
                    </a>
                  </ng-container>
                  <ng-container *ngSwitchCase="'string-array'">
                    {{dataItem | getValue:columnInfo | formatArray:'string'}}
                  </ng-container>
                  <ng-container *ngSwitchCase="'number-array'">
                    {{dataItem | getValue:columnInfo | formatArray:'number'}}
                  </ng-container>
                  <ng-container *ngSwitchCase="'image'">
                    <img *ngIf="getValuePipe.transform(dataItem, columnInfo)"
                      [src]="getValuePipe.transform(dataItem, columnInfo)" alt="Preview image">
                    <div class="noImageBox" *ngIf="!getValuePipe.transform(dataItem, columnInfo)">
                      <mits-icon name="image"></mits-icon>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'badge'">
                    <mits-badge [value]="dataItem | getValue:columnInfo"></mits-badge>
                  </ng-container>
                  <div *ngSwitchCase="'entity-type'">
                    {{dataItem | getValue:columnInfo | objectType}}
                  </div>
                  <ng-container *ngSwitchDefault>
                    {{dataItem | getValue:columnInfo}}
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
            <td *ngIf="table.enableInlineEditing || table.actionsMenuButtons?.length > 0"
              [ngStyle]="{'width': table.actionsMenuColumnWidth + 'px'}">
              <span class="mitsTableButtonsCol">
                <ng-container *ngIf="showActionMenu; else elseActionButtons">
                  <span *ngIf="actionMenuButtons?.length > 0" class="mitsTableButton"
                    (click)="$event.stopPropagation(); buttonsPopoverElement.toggle($event)">
                    <mits-icon name="more-alt"></mits-icon>
                    <mits-buttons-popover #buttonsPopoverElement [buttons]="actionMenuButtons" [indexOptionalData]="i"
                      [optionalData]="dataItem">
                    </mits-buttons-popover>
                  </span>
                </ng-container>
                <ng-template #elseActionButtons>
                  <ng-container *ngFor="let button of actionMenuButtons; let first = first">
                    <span *ngIf="!(button.hidden || (button.hiddenFunc && button.hiddenFunc(dataItem)))"
                      class="mitsTableButton"
                      [ngStyle]="{'background-color': button.style === 'button' ? button.color : 'rgba(0,0,0,0)'}"
                      [ngClass]="{'disabled': button.disabled || (button.disabledFunc && button.disabledFunc(dataItem)), 'buttonStyle': button.style === 'button'}"
                      (click)="clickedButton(button, $event, dataItem, i)">
                      <mits-icon [name]="button.icon"
                        [ngStyle]="{'color': button.style === 'button' ? 'white' : button.color}"></mits-icon>
                    </span>
                  </ng-container>
                </ng-template>
              </span>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </span>

  <span class="mitsTableFooter" *ngIf="table.provider && pageInfo">
    <span class="mitsTableButton" (click)="clickFirstPageButton($event)" [ngClass]="{'disabled': pageInfo.page === 1}">
      <mits-icon name="push-left"></mits-icon>
    </span>
    <span class="mitsTableButton leftSeperator" (click)="clickPrevPageButton($event)"
      [ngClass]="{'disabled': pageInfo.page === 1}">
      <mits-icon name="arrow-left"></mits-icon>
    </span>
    <span class="mitsTableButton leftSeperator active widen" [ngClass]="{'disabled': pageInfo.pages <= 1}">
      <input type="number" class="mitsTableInput" #pageInput [value]="pageInfo.page" (input)="inputSpecificPage($event)"
        [disabled]="pageInfo.pages <= 1">
    </span>
    <span class="mitsTableButton leftSeperator" (click)="clickNextPageButton($event)"
      [ngClass]="{'disabled': pageInfo.page === pageInfo.last}">
      <mits-icon name="arrow-right"></mits-icon>
    </span>
    <span class="mitsTableButton leftSeperator" (click)="clickLastPageButton($event)"
      [ngClass]="{'disabled': pageInfo.page === pageInfo.last}">
      <mits-icon name="push-right"></mits-icon>
    </span>
  </span>
</span>